import { deleteOrder } from "../order/actions";
import { ORDER_DELETE_FAIL, ORDER_DELETE_REQUEST } from "../order/actionType";
import axios from "./utils/axios";

const fetchDeleteOrder = (orderNumber) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_DELETE_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.delete(
        `api/order/delete/${orderNumber}/`,
        config
      );
      dispatch(deleteOrder(data));
    } catch (error) {
      dispatch({
        type: ORDER_DELETE_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchDeleteOrder;
